<div
  class="toggle-container"
  [ngClass]="config.hierarchy"
  [class.disabled]="isDisabled"
>
  <button
    type="button"
    *ngFor="let button of this.config.viewValues; let i = index"
    class="qr-toggle subheading-01-semi-bold"
    [style.height.px]="config?.size"
    [ngClass]="config.hierarchy"
    [class.qr-toggle--custom]="isCustomOption(i)"
    [class.selected]="i == config?.optionSelected"
    [class.disabled]="isDisabled"
    matRipple
    (click)="select(i)"
    [matTooltip]="getTooltip(i)"
  >
    <ng-container>
      <qr-icon
        *ngIf="config.icons && config.icons[i]"
        [name]="config.icons[i]"
        [color]="iconsColor.get(i) ?? '-'"
      ></qr-icon>
      <ng-container *ngIf="isCustomOption(i); else staticLabel">
        <span class="qr-toggle__custom">
          <span class="qr-toggle__custom-prefix" *ngIf="getCustomPrefix()">{{
            getCustomPrefix()
          }}</span>
          <span class="qr-toggle__custom-field">
            <span class="qr-toggle__custom-label">
              <span
                class="qr-toggle__custom-value-slot"
                [class.qr-toggle__custom-value-slot--empty]="!hasCustomValue()"
              >
                <span
                  *ngIf="!hasCustomValue()"
                  class="qr-toggle__custom-field-line"
                ></span>
                <input
                  *ngIf="i === config.optionSelected"
                  type="text"
                  inputmode="numeric"
                  pattern="[0-9]*"
                  autocomplete="off"
                  class="qr-toggle__custom-input"
                  [attr.size]="getCustomInputSize()"
                  [disabled]="isDisabled"
                  [value]="customInputDisplay"
                  (input)="onCustomInputChange($any($event.target).value)"
                  (keydown)="onCustomInputKeydown($event)"
                  (paste)="onCustomInputPaste($event)"
                  (change)="stopInputEvent($event)"
                  (click)="stopInputEvent($event)"
                  (mousedown)="stopInputEvent($event)"
                />
                <span
                  *ngIf="i !== config.optionSelected && hasCustomValue()"
                  class="qr-toggle__custom-value"
                  >{{ getCustomValueDisplay() }}</span
                >
              </span>
              <span class="qr-toggle__custom-unit">M</span>
            </span>
            <qr-icon
              class="qr-toggle__custom-edit-icon"
              [name]="ICON_PENCIL"
              [color]="ICON_COLOR_GREY_700"
              [size]="32"
            ></qr-icon>
          </span>
        </span>
      </ng-container>
      <ng-template #staticLabel>
        {{ button }}
      </ng-template>
    </ng-container>
  </button>
  <div class="toggle-background"></div>
</div>
